module.exports = __webpack_public_path__ + "img/imtoken.56c6369e.png";